export enum LoanStatus {
    SIGNED = 'SIGNED',
    UNSIGNED = 'UNSIGNED',
    REJECTED = 'REJECTED',
    EXPIRED = 'EXPIRED'
}